import script from "./add-edit-daily-verse.vue?vue&type=script&setup=true&lang=js"
export * from "./add-edit-daily-verse.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__